import { render, staticRenderFns } from "./VipCreate.vue?vue&type=template&id=caa65ea0&scoped=true"
import script from "./VipCreate.vue?vue&type=script&lang=js"
export * from "./VipCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa65ea0",
  null
  
)

export default component.exports